import * as React from "react";
import { ActivityNavbar } from '../../../Shared/index';
import { DropdownObjectInterface } from "../../../Staff/interfaces/evidenceInterfaces";

interface TeacherNavbarProps {
  isELLDiagnostic: boolean;
  isOnMobile: boolean;
  language: string;
  languageOptions: DropdownObjectInterface[];
  onTogglePreview?: () => void;
  previewShowing?: boolean;
  translate: (language: string) => string;
  updateLanguage: (language: string) => void;
}

export const TeacherNavbar: React.FC<TeacherNavbarProps> = (props) => (
  <ActivityNavbar
    checkTeacherIdentity={false}
    isELLDiagnostic={props.isELLDiagnostic}
    isOnMobile={props.isOnMobile}
    language={props.language}
    languageOptions={props.languageOptions}
    onTogglePreview={props.onTogglePreview}
    previewShowing={props.previewShowing}
    showLanguagePicker={true}
    showTeacherPreview={true}
    toolName="diagnostic"
    translate={props.translate}
    updateLanguage={props.updateLanguage}
    useShowTranslationsCheck={false}
  />
);

export default TeacherNavbar;
